export enum ReportTypes {
  Unknown = 0,
  PDG = 1,
  TDG = 2,
  CDG = 3,
  TMJ = 4,
  UserReport = 5,
  CompareReport = 6,
  CampaignReportTdg = 7,
  CampaignReportCdg = 8,
  UserCompletion = 9,
  OrganisationReportCdg = 10,
  AllDataReportTdg = 11,
  PersonalEditionPdg = 12
}
